import { UserSettings } from '@griply/types';

export enum GoalCompletedContext {
  GoalsOverview = 'goals-overview',
  LifeAreaDetail = 'life-area-detail',
  GoalDetail = 'goal-detail',
}

export const getShowCompletedGoals = (
  settings: UserSettings | undefined,
  context: GoalCompletedContext,
): boolean => {
  if (context === GoalCompletedContext.LifeAreaDetail) {
    return settings?.lifeAreaDetail?.goals?.showCompletedGoals ?? true;
  }
  if (context === GoalCompletedContext.GoalDetail) {
    return settings?.goalDetail?.roadmap?.showCompletedGoals ?? true;
  }
  return settings?.goalsOverview?.roadmap?.showCompletedGoals ?? true;
};

export const buildShowCompletedGoalsUpdate = (
  context: GoalCompletedContext,
  value: boolean,
): Partial<UserSettings> => {
  if (context === GoalCompletedContext.LifeAreaDetail) {
    return { lifeAreaDetail: { goals: { showCompletedGoals: value } } };
  }
  if (context === GoalCompletedContext.GoalDetail) {
    return { goalDetail: { roadmap: { showCompletedGoals: value } } };
  }
  return { goalsOverview: { roadmap: { showCompletedGoals: value } } };
};
